<template>
  <DialogTemplate
    :desktopFullscreen="true"
    :dark="true"
    class="nodelock-dialog ndlcdlg"
    style="--dialog-content-padding: var(--ndlcdlg-padding)"
  >
    <SolfigrNodeLock
      ref="form"
      class="flex-1"
      :namespace="tmpNamespace"
      :primaryNamespace="namespace"
      :hotkeysPressed="hotkeysPressed"
      @close="close"
    />
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import SolfigrNodeLock from '@/components/Dialogs/Solfigr/SolfigrNodeLock'

export default {
  name: 'SolfigrNodeLockDialog',
  components: {
    SolfigrNodeLock,
    DialogTemplate,
  },
  props: {
    dialog: Object,
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$store.dispatch('router_rm_dialog', 'solfigr-nodeedit-dialog')
    },
  },
  computed: {
    hotkeysPressed() {
      return this.$store.getters.hotkeys_pressed
    },
    namespace() {
      return this.dialog.namespace || ''
    },
    tmpNamespace() {
      return this.dialog.tmpNamespace || ''
    },
  },
}
</script>

<style lang="scss" scoped>
.ndlcdlg {
  --ndlcdlg-padding: 0rem;
}

@media (max-width: 1023px) {
  .ndlcdlg {
    // --ndlcdlg-padding: 2.5rem 0 0.5rem 0;
    // --ndlcdlg-padding: 2.5rem 0 0.25rem 0;
    --ndlcdlg-padding: 2.5rem 0 0 0;
  }
}
</style>
